import { PageType } from '@app-types/PageType'
import Button from '@components/Button/Button'
import { useUserData } from '@contexts/UserDataContext'
import { useLocalStorage } from '@hooks/useLocalStorage'
import usePagination from '@hooks/usePage'
import { ChangeEvent, FC, useEffect, useState, type FormEvent } from 'react'

type BottomPaginationProps = {
  type: PageType
  max: number
  min?: number
  basePath?: string
  mobileReader?: boolean
}

const BottomPagination: FC<BottomPaginationProps> = ({
  type,
  max,
  min = 1,
  basePath = '',
  mobileReader = false,
}) => {
  const { nextPage, page, previousPage, goToPage } = usePagination({
    path: type,
    max,
    min,
    addEventListener: false,
    basePath,
    mobileReader,
  })
  const [counter, setCounter] = useLocalStorage(`${type}Counter`, 0)

  const [pageForInput, setPageForInput] = useState(page)

  const onPageChangeSubmit = (event: FormEvent) => {
    event.preventDefault()
    goToPage(pageForInput)
  }

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setPageForInput(Number(event.target.value))
  }

  useEffect(() => {
    setPageForInput(page)
  }, [page])

  const { userData } = useUserData()

  const difference = Number(page) - Number(userData[type])
  const isLastPage = Number(page) === max
  return (
    <div className="flex-col flex-center" data-reading-page-end="true">
      {isLastPage && (
        <>
          <div className="flex flex-center gap-2">
            <Button onClick={() => goToPage(1)}>Başa Dön</Button>

            <Button
              className="whitespace-nowrap"
              onDoubleClick={() => {
                setCounter(0)
              }}
              onClick={() => setCounter(counter + 1)}
            >
              {counter} defa bitirildi{' '}
            </Button>
          </div>
          <small className="mt-2">
            Sayfayı okuduğunuzda tıklayarak sayacı arttırabilir, çift tıklayarak
            sıfırlayabilirsiniz.
          </small>
        </>
      )}

      <div className="flex-center mt-4 mb-1">
        <Button
          onClick={previousPage}
          className="dark:bg-gray-600 mr-2 py-1 w-[120px] text-sm dark:text-gray-200"
          disabled={Number(page) === min}
        >
          Önceki Sayfa
        </Button>
        <form onSubmit={onPageChangeSubmit}>
          <input
            className="bg-slate-200 border rounded-full w-20 h-[30px] font-medium text-center dark:text-gray-800"
            type="number"
            name="page"
            id="bottom-pagination-page"
            max={max}
            min={min}
            value={pageForInput}
            onChange={onChangeHandler}
            aria-label="Sayfa numarası"
          />
        </form>
        <Button
          onClick={nextPage}
          className="dark:bg-gray-600 ml-2 py-1 w-[120px] text-sm dark:text-gray-200 whitespace-nowrap"
          disabled={isLastPage}
        >
          Sonraki Sayfa
        </Button>
      </div>
      <div className="mb-1">
        <small>
          {difference ? `${difference} sayfa okundu` : ''}
          {difference && counter ? ' | ' : ''}
          {counter ? `${counter} defa bitirildi` : ''}
        </small>
      </div>
    </div>
  )
}

export default BottomPagination
